<h1 class="page-title w-50"> وحدة رعاية المستثمرين المصريين المقيمين بالخارج </h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <p class="lead mb-4">
      في إطار حرص الدولة على الاهتمام بأبنائها من الجاليات المصرية المقيمة بالخارج، وبالتعاون مع وزارة الهجرة وشؤون
      المصريين بالخارج، تم إنشاء "وحدة رعاية المستثمرين المصريين المقيمين بالخارج" وتتابع تلك الوحدة عملها التنفيذي
      للهيئة العامة للاستثمار والمناطق الحرة.
    </p>

    <h3 class="h5 mt-4">الخدمات:</h3>
    <ul class="list-unstyled mb-4">
      <li>• تقديم الدعم الفني والمشورة للمساعدة في اتخاذ قرار الاستثمار من خلال التعريف بنظم الاستثمار المختلفة والحوافز
        والضمانات المقدمة بقانون الاستثمار المصري.</li>
      <li>• عرض الفرص الاستثمارية بمختلف القطاعات وتيسير الحصول على الخدمات التي تقدمها الجهات المعنية.</li>
      <li>• القيام بدور حلقة الوصل بين المصريين بالخارج والجهات المعنية في مصر خلال مختلف مراحل ممارسة النشاط.</li>
    </ul>

    <h3 class="h5 mt-3">القطاعات المستهدفة للاستثمار:</h3>
    <ul class="mb-4" style="column-count:2; column-gap: 40px;">
      <li>الصناعة</li>
      <li>الزراعة</li>
      <li>الخدمات اللوجستية</li>
      <li>تكنولوجيا المعلومات والاتصالات</li>
      <li>الرعاية الصحية</li>
      <li>التعليم</li>
    </ul>

    <p class="mb-4">ومن هذا المنطلق، تطلع الوحدة للتعرف على رغبات الاستثمار الخاصة بالمصريين المقيمين بالخارج، ويمكنكم
      تعبئة الاستمارة من خلال الرابط التالي: <a href="https://forms.gle/cgM2fgCVptHvSShDA" target="_blank">تتبع ملئ
        الفورم </a></p>

    <p class="mb-3">لتحميل الفلاير التعريفي: <a href="/assets/وحدة المصريين بالخارج فلاير عربي.pdf" target="_blank"
        class="btn btn-sm btn-outline-primary ms-2"><i class="fa-regular fa-file-pdf"></i> فتح الفلاير (PDF)</a></p>
  </div>

  <div class=" p-3">
    <h4 class="h6">المزيد من المعلومات يمكن التواصل من خلال:</h4>
    <p class="mb-1"><strong>الخط الساخن:</strong> 16035</p>
    <p class="mb-1"><strong>داخلي:</strong> 6079, 6842, 6843, 6875, 6864</p>
    <p class="mb-1"><strong>بريد إلكتروني:</strong> <a
        href="mailto:expatsunit&#64;gafinet.org.eg">expatsunit&#64;gafinet.org.eg</a></p>
  </div>
</div>